import TypeSelectorRow from "./TypeSelectorRow";

export default TypeSelectorRow;